import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  width?: number;
  style?: FelaCSS;
}

const ProgressBarMarker = ({ id, width = 18, style = {}, ...restProps }: IProps) => {
  const viewBoxWidth = 18;
  const viewBoxHeight = 18;

  const icon = () => (
    <svg
      width={`${width}px`}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.71014C0 3.54695 0 1.96535 0.982677 0.982677C1.96535 0 3.54695 0 6.71014 0H11.2899C14.4531 0 16.0346 0 17.0173 0.982677C18 1.96535 18 3.54695 18 6.71014V11.2899C18 14.4531 18 16.0346 17.0173 17.0173C16.0346 18 14.4531 18 11.2899 18H6.71014C3.54695 18 1.96535 18 0.982677 17.0173C0 16.0346 0 14.4531 0 11.2899V6.71014Z"
        fill="#4D52E3"
      />
      <path
        d="M9.86479 7.33334V8.13522L10.6667 8.13522C12.0648 8.13523 13.1981 9.2686 13.1981 10.6667C13.1981 12.0647 12.0647 13.1981 10.6667 13.1981H4.80189V7.33334C4.80189 5.93526 5.93526 4.80189 7.33334 4.80189C8.73142 4.80189 9.86479 5.93526 9.86479 7.33334Z"
        stroke="white"
        strokeWidth="1.60377"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default ProgressBarMarker;
